export default "<div id=\"mobileLayer\">\n    <div class=\"content\"></div>\n</div>\n";